import * as qs from 'qs';
import { ServiceMapper } from './ServiceMapper.js';
import { ServiceDetailsMapper } from './ServiceDetails/ServiceDetailsMapper.js';
import { ServiceAvailableDateMapper } from './ServiceAvailableDate/ServiceAvailableDateMapper.js';

const serviceAllParamSerializer = parameters => {
  return qs.stringify(parameters);
};
class ServiceRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  all(_ref) {
    let {
      sortBy,
      ...rest
    } = _ref;
    return this.apiClient.get('v1/services', {
      ...this.apiClient.withRequestContext(),
      sort_by: sortBy,
      ...rest
    }, undefined, serviceAllParamSerializer).then(response => response.data.map(res => ServiceMapper.createFromResponse(res)));
  }
  getDetails(service) {
    return this.apiClient.get(`v1/services/${service.id}`, {
      ...this.apiClient.withRequestContext()
    }).then(response => ServiceDetailsMapper.createFromResponse(response.data));
  }
  getCollectionDates(shipments) {
    return this.apiClient.post('v1/services/collection-dates-bulk', {
      shipments
    }).then(response => {
      return ServiceAvailableDateMapper.getSortedAvailableDates(response.data);
    });
  }
  getServicesForMultipleShipments(_ref2) {
    let {
      shipments,
      sortBy
    } = _ref2;
    return this.apiClient.post('pro/services-bulk', {
      shipments
    }, {
      sort_by: sortBy
    }).then(response => response.data.map(service => ServiceMapper.createFromResponse({
      ...service,
      // Values that are unknown because each shipment can have a different route
      price: {
        base_price: 0,
        tax_price: 0,
        total_price: 0,
        items: []
      },
      insurance: {
        base_insurance: '0',
        max_insurance: '0',
        additional_insurance: true
      },
      tags: []
    })));
  }
  getServicesForSpecificSearch(_ref3) {
    let {
      sortBy,
      ...rest
    } = _ref3;
    return this.apiClient.post('pro/services', {
      ...this.apiClient.withRequestContext(),
      sort_by: sortBy,
      ...rest
    }, undefined, undefined, undefined, serviceAllParamSerializer).then(response => response.data.map(res => ServiceMapper.createFromResponse(res)));
  }
}

export { ServiceRepository, serviceAllParamSerializer };
//# sourceMappingURL=ServiceRepository.js.map
